import { parseQueryString } from './uri';

// Server-validated redirect target only: the raw `to` query parameter is attacker-controlled
// (reflected XSS via e.g. `to=javascript:...`) and must never reach navigation or an href.
// This check is defence-in-depth on top of the server-side allowlist, not a substitute for it.
export function isSafeRedirectUri(redirectUri) {
  if (!redirectUri) {
    return false;
  }
  try {
    const { protocol } = new URL(redirectUri, global.window.location.origin);
    return protocol === 'https:' || protocol === 'http:';
  } catch {
    return false;
  }
}

export function performRedirectTo(redirectUri, navigate = (url) => (global.window.location.href = url)) {
  if (isSafeRedirectUri(redirectUri)) {
    navigate(redirectUri);
  }
}

export function hasRedirectQueryParam() {
  return parseQueryString(global.window.location.search).to !== undefined;
}

export function authenticateUriWithRedirectToFromQuery() {
  const { to, applicationId } = parseQueryString(global.window.location.search);
  if (to && applicationId) {
    return authenticateUriWithRedirectTo(applicationId, to);
  } else {
    return '/';
  }
}

export function authenticateUriWithRedirectTo(applicationId, to) {
  return `/google/authenticate?to=${encodeURIComponent(to)}&applicationId=${encodeURIComponent(applicationId)}`;
}
